


import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Divider,
} from '@mui/material';
import { History, AccessTime, Bolt, Water, PunchClock } from '@mui/icons-material';
import SectionHeader from './SectionHeader';
import { useAuth } from './../../../AuthContext';

const PastSessions = () => {
  const { pumpSessions, value: pumpImei,formatDuration } = useAuth();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Process and sort sessions
  // useEffect(() => {
  //   if (!pumpImei || !pumpSessions) {
  //     setSessions([]);
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const processedSessions = pumpSessions
  //       .map((session, index) => ({
  //         id: session._id || `session-${index}`,
  //         timeRange: `${session.on_time || 'Unknown'} - ${session.off_time || 'Unknown'}`,
  //         duration: session.duration ? `${session.duration} minutes` : 'N/A',
  //         energy: session.energy_consumed ? `${session.energy_consumed} kWh` : 'N/A',
  //         water: session.water_discharge ? `${session.water_discharge} L` : 'N/A',
  //         onTime: session.on_time ? new Date(session.on_time) : new Date(0), // For sorting
  //       }))
  //       .sort((a, b) => b.onTime - a.onTime); // Newest first

  //     setSessions(processedSessions);
  //   } catch (error) {
  //     console.error('Error processing sessions:', error);
  //     setSessions([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [pumpSessions, pumpImei]);


  useEffect(() => {
    if (!pumpImei || !pumpSessions) {
      setSessions([]);
      return;
    }
  
    
  
    setLoading(true);
    try {
      const processedSessions = pumpSessions
        .map((session, index) => ({
          id: session._id || `session-${index}`,
          timeRange: `${session.on_time || 'Unknown'} - ${session.off_time || 'Unknown'}`,
          duration: session.duration ? formatDuration(session.duration) : 'N/A',
          energy: session.energy_consumed ? `${(session.energy_consumed).toFixed(3)} kWh` : '0',
          water: session.water_discharge ? `${(session.water_discharge).toFixed(2)} L` : '0',
          onTime: session.on_time ? new Date(session.on_time) : new Date(0), // For sorting
        }))
        .sort((a, b) => b.onTime - a.onTime); // Newest first
  
      setSessions(processedSessions);
    } catch (error) {
      console.error('Error processing sessions:', error);
      setSessions([]);
    } finally {
      setLoading(false);
    }
  }, [pumpSessions, pumpImei]);

  return (
    <Paper
      sx={{
        borderRadius: 2 * 2,
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 2,
      }}
    >
      <SectionHeader icon={<History fontSize="small" />} title="Past Sessions" />
      <Box sx={{ p: 2, flex: 1, overflow: 'hidden' }}>
        {loading ? (
          <Typography variant="body1" align="center">
            Loading sessions...
          </Typography>
        ) : sessions.length === 0 ? (
          <Typography variant="body1" align="center">
            No past sessions found for this pump.
          </Typography>
        ) : (
          <TableContainer
            sx={{
              maxHeight: '400px', // Responsive height
              overflowY: 'auto',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Time Interval
                     
                    </Typography>
                   <AccessTime fontSize="small" color="action" style={{marginTop:'24px'}} />
                   
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                     Pump Duration

                    </Typography>
                    <PunchClock fontSize="small" color="primary" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Energy Consumed
                    
                    </Typography>
                    <Bolt fontSize="small" color="primary" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={'1rem'}>
                      Water Discharged
              
                    </Typography>
                    <Water fontSize="small" color="primary" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sessions.map((session, index) => (
                  <React.Fragment key={session.id}>
                    <TableRow hover>
                    <TableCell>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography variant="body2">
      {(() => {
        const [start, end] = session.timeRange.split(" - ");
        const startIST = new Date(start).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          hour12: true,
        });
        const endIST = new Date(end).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          hour12: true,
        });
        return `${startIST} - ${endIST}`;
      })()}
    </Typography>
  </Box>
</TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {session.duration}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         
                          <Typography variant="body2" color="primary.main">
                            {session.energy}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      
                          <Typography variant="body2" color="primary.main">
                            {session.water}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                    {index < sessions.length - 1 && (
                      <TableRow>
                        <TableCell colSpan={4} sx={{ p: 0 }}>
                          <Divider sx={{ my: 0.5 }} />
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Paper>
  );
};

export default PastSessions;

